import store from '@/store';
import axios from 'axios';
const baseUrl = process.env.VUE_APP_API_URL;
const instance = axios.create({
    baseURL: baseUrl
})
export default function (options = {}) {
    const {shouldNotLogout} = options;
    if (store.state.tokenRefreshing && store.state.refreshTask) {
        return store.state.refreshTask;
    }

    store.commit('setTokenRefreshing', true);
    const refreshToken = localStorage.getItem('refreshToken');
    const accessToken = localStorage.getItem('token');

    if (!refreshToken || !accessToken) {
        if (!shouldNotLogout) store.dispatch('logout');
        store.commit('setTokenRefreshing', false);
        return Promise.reject('No Refresh token or accessToken');
    }

    const refreshingCall = instance.post(baseUrl + '/auth/web-refresh-token', { accessToken, refreshToken }).then(({ data }) => {
        store.commit('loggedIn', data);
        store.commit('setTokenRefreshing', false);
        store.commit('refreshTask', undefined);
        return Promise.resolve(true);
    }).catch(e => {
        store.commit('refreshTask', undefined);
        store.commit('setTokenRefreshing', false);
        return Promise.reject(e);
    });
    store.commit('refreshTask', refreshingCall);
    return refreshingCall;
}